module.exports = __webpack_public_path__ + "img/multi-five.ac3bee82.svg";